module.exports = "https://cdn-static.kwai.net/kos/s101/nlav11312/kibt-fe-shop-c-outside-h5/prod/images/merchant_free_shipping_benefit.7c2d6141ec.png";